/**
 *  Site disc text
 */

( function ( document ) {
  /**
     *  Main ini function
     */
  function init () {
    $('a.submit').on('click', function (e) {
      e.preventDefault();

      let _this = $(this);
      let error = false;

        let fname = $(this).closest('.fields').find('input[name="fname"]');
        let lname = $(this).closest('.fields').find('input[name="lname"]');
        let email = $(this).closest('.fields').find('input[name="email"]');

        if(fname.val() == '' || ! /^[a-zA-Z\-]+$/.test(fname.val())) {
          fname.closest('.item-field').addClass('error');
          error = true;
        }

      if (lname.val() == '' || ! /^[a-zA-Z\-]+$/.test(lname.val())) {
        lname.closest('.item-field').addClass('error');
        error = true;
      }

      if (email.val() == ''|| ! /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(email.val())) {
        email.closest('.item-field').addClass('error');
        error = true;
      }

      if (! error) {
        let email_address = email.val();

        let url = 'https://sweeps.svc.ds.amcn.com/' +
            '?channel=amc' +
            '&sweeps-id=1386804' +
            '&application=sweeps' +
            '&application_xid=1386804' +
            '&action=submit' +
            '&leanplum_ids=better-call-saul-nl' +
            '&email=' + encodeURIComponent(email_address);

        $.ajax({
          dataType: 'jsonp',
          url: url,
          success: function (response) {
            if (response.error) {
              if (response.message && response.message.search('Already entered') >= 0) {
                alert('That email has already been registered. Please try another.');
              } else {
                alert('Subscription failed!');
              }
            } else {
              _this.closest('.newsletter-form').addClass('sent');
            }
          },
          error: function (request, status, err) {
            console.error('Signup failed.', err);
            alert('Subscription failed!');
          },
        });
      }
    });

    $('.form input, .form-mobile input').on('click', function () {
      $('.form .item-field, .form-mobile .item-field').removeClass('error');
    });
  }

  document.addEventListener( 'DOMContentLoaded', init );
}( document ));



// WEBPACK FOOTER //
// ./js/scripts/components/_site_form.js